import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { LoadingBarService } from "@ngx-loading-bar/core";

import { HeaderService, ServiceProvidersService } from "../../../shared";

@Component({
  selector: "app-service-providers-list",
  templateUrl: "./service-providers-list.component.html",
  styleUrls: ["./service-providers-list.component.scss"]
})
export class ServiceProvidersListComponent implements OnInit {
  typeComponent = "service-providers";

  textBtnNew = "Novo Prestador";
  urlBtnNew = "/panel/service-providers/new";

  currentUrl = "/panel/service-providers";

  dataList;

  pag;
  filters;
  cacheObj;

  equipmentRequest;

  totalServiceProvider;

  constructor(
    private headerService: HeaderService,
    private serviceProvidersService: ServiceProvidersService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.activatedRoute.snapshot.params.pag) {
      this.pag = this.activatedRoute.snapshot.params.pag;
    } else {
      this.pag = 1;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle("Prestadores de serviço");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);

    this.dataList = {};

    this.translateFilter();
  }

  equipmentList(filters = "") {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if (this.equipmentRequest) {
      this.equipmentRequest.unsubscribe();
    }

    this.equipmentRequest = this.serviceProvidersService
      .listServiceProviders(filters)
      .subscribe(response => {
        this.loadingBarService.complete();

        this.dataList = response;

        this.totalServiceProvider = response["total"];
      });
  }

  setPag(setPag) {
    this.pag = setPag;

    this.translateFilter();
  }

  translateFilter(obj?) {
    this.filters = [];

    if (obj) {
      this.cacheObj = obj;
    }

    _.forOwn(this.cacheObj, (value, key) => {
      this.filters.push(`${key}=${value}`);
    });

    this.equipmentList(
      `?pageNumber=${this.pag}${
        this.filters.length !== 0 ? "&" : ""
      }${this.filters.join("&")}`
    );
  }
}
